import "core-js/modules/es.array.push.js";
import { SET_MODAL_OPEN, SET_MODAL_DATA, SET_MODAL_CONTAINER, CLEAR_MODAL_DATA, UPDATE_SELECTED_COLOR, CLEAR_TEMP_COLOR, CLEAR_COLOR_ERROR, UPDATE_SELECTED_SIZE, UPDATE_INVENTORY, CLEAR_SIZE_ERROR, UPDATE_QUANTITY, CLEAR_QUANTITY_ERROR, UPDATE_TEMP_COLOR, CLEAR_FULFILLMENT_ERROR, UPDATE_SHIPPING_METHOD, UPDATE_SELECTED_STORE, CLEAR_STORE_DATA, SET_BY_STORE_DATA, SET_STORE_DATA_ERROR, UPDATE_STORE_SEARCH_GEOLOCATION, SET_GEOLOCATION_ALLOWED, UPDATE_STORE_SEARCH_TERM, UPDATE_STORE_SEARCH_ERROR, UPDATE_STORE_SEARCH_WARNING, SET_GEOLOCATION_ERROR, UPDATE_STORE_SEARCH_PROBLEM_MESSAGE, UPDATE_STORE_SEARCH_BOX_REF, UPDATE_STORES_LOADING, UPDATE_BUYBOX_VALIDATION, UPDATE_RECOMMENDATIONS_SCRIPT_STATUS, UPDATE_RECOMMENDATIONS_PLACEMENTS, UPDATE_BV_SCRIPT_STATUS, UPDATE_WISHLISTS, UPDATE_WISHLIST_ERROR, SET_CURRENT_WISHLIST, CLEAR_SELECTED_WISHLIST, UPDATE_CART_DATA, UPDATE_CART_ERROR_DATA, UPDATE_CART_LOAD_STATUS, UPDATE_USER, TOGGLE_ACCORDION_SECTION, TOGGLE_ACCORDION_VISIBILITY, UPDATE_HERO_IMAGE, SET_USE_VERTICAL_ANIMATION, SET_ARIA_LIVE_MESSAGE, SET_ARIA_LIVE_POLITENESS, SET_RECS_COMPONENT, SET_BOPUS_ANALYTICS_LINKNAME, SET_SIZE_HOVER_NAME, UPDATE_SELECTED_SKU, CLEAR_SKU_ERROR, UPDATE_VIEWED_SKUS, UPDATE_ACCEPT_TERMS, UPDATE_SELECTED_PRICE, SET_HOVER_PRICE, UPDATE_INCLUDE_MEMBERSHIP, CLEAR_MEMBERSHIP_ERROR, SHOW_ZOOM, SET_IMAGE_ZOOM_REF, SET_TOUCH_LIBRARY, SET_USER_SUBSCRIPTION, UPDATE_NOTIFY_ME_EMAIL, SET_NOTIFY_ME_ERROR, CLEAR_NOTIFY_ME_ERROR, UPDATE_NOTIFY_ME_SUCCESS, UPDATE_CART_LOAD_MEMBERSHIP_STATUS, UPDATE_ADOBE_TEST_DATA, UPDATE_URL_SEARCH_PARAMS, UPDATE_SIZE_FINDER_RESULTS, UPDATE_SIZE_FINDER_FEET_SELECTED, UPDATE_SIZE_FINDER_INCHES_SELECTED, UPDATE_COMPONENT_MOUNTED, UPDATE_SHIPPING_ADDRESS, UPDATE_PICKUP_MODAL_STORE, UPDATE_SHIPPING_AVAILABILITY, CLEAR_SHIPPING_AVAILABILITY, SET_INLINE_SHIP_EDITOR_OPEN, SET_INLINE_SHIP_LOADING, SET_SHIP_GEO_ERROR, SET_INLINE_SHIP_INVALID, SET_HAS_EAD_NETWORK_ERROR, SET_NO_STORE_AVAILABLE, SET_NO_LOCATION_AVAILABLE, SET_USER_DEFINED_STORE, SET_UGC_IMAGES, SET_CURRENT_UGC_PRODUCT, LIMIT_INSTOCK_STORES, SET_MEMBERSHIP_ADDED_TO_CART_STATUS, SET_SHOW_ATC_INTERSTITIAL, SET_POP_STATE_CB, SET_CART_MICROSERVICE_DATA, SET_CART_SUMMARY, SET_CART_MICROSERVICE_ERROR_DATA, SET_PRODUCT_INSIGHT, SET_CUSTOMER_ATTRIBUTES, SET_OVER_REQUEST_MESSAGE, SET_STORYTELLING_DATA, SET_ADVICE_DATA, SET_CURATED_OUTFIT_DATA, SET_ORDER_ISSUES, UPDATE_KLARNA_SCRIPT_STATUS } from "./constants.mjs";
const mutations = {
  [SET_MODAL_OPEN](state, openModal) {
    state.modalIsOpen = openModal;
  },
  [SET_MODAL_DATA](state, modalData) {
    state.modalData = modalData;
  },
  [SET_MODAL_CONTAINER](state, container) {
    state.modalContainer = container;
  },
  [CLEAR_MODAL_DATA](state) {
    state.modalData = {
      label: "",
      modalContent: "",
      modalProps: {},
      dynamic: false
    };
  },
  [UPDATE_SELECTED_COLOR](state, color) {
    state.selectedColor = color;
  },
  [CLEAR_TEMP_COLOR](state) {
    state.tempColor = {};
  },
  [CLEAR_COLOR_ERROR](state) {
    state.buyBoxValidation.color.hasError = false;
  },
  [UPDATE_SELECTED_SIZE](state, size) {
    state.selectedSize = size;
  },
  [UPDATE_INVENTORY](state, skuMap) {
    state.inventory.skuMap = skuMap;
    state.inventory.loaded = true;
  },
  [CLEAR_SIZE_ERROR](state) {
    state.buyBoxValidation.size.hasError = false;
  },
  [UPDATE_QUANTITY](state, qty) {
    const intQty = +qty;
    state.quantity = intQty;
  },
  [CLEAR_QUANTITY_ERROR](state) {
    state.buyBoxValidation.quantity.hasError = false;
  },
  [UPDATE_TEMP_COLOR](state, color) {
    state.tempColor = color.displayLabel ? color : {};
  },
  [CLEAR_FULFILLMENT_ERROR](state) {
    state.buyBoxValidation.fulfillment.hasError = false;
    state.buyBoxValidation.shipTile.hasError = false;
    state.buyBoxValidation.pickupTile.hasError = false;
  },
  [UPDATE_SHIPPING_METHOD](state, shippingMethod) {
    state.shipping.shippingMethod = shippingMethod;
  },
  [UPDATE_SELECTED_STORE](state, store) {
    state.shipping.selectedStore = store;
  },
  [CLEAR_STORE_DATA](state) {
    state.storeData.blueYonderResponseData = [];
  },
  [SET_BY_STORE_DATA](state, response) {
    state.storeData.blueYonderResponseData = response;
  },
  [SET_STORE_DATA_ERROR](state, errorResult) {
    state.storeData.fulfillmentError = errorResult;
  },
  [UPDATE_STORE_SEARCH_GEOLOCATION](state, {
    latitude,
    longitude
  }) {
    state.storeData.geoLocation = {
      latitude,
      longitude
    };
  },
  [SET_GEOLOCATION_ALLOWED](state, status) {
    state.storeData.allowsGeo = status;
  },
  [UPDATE_STORE_SEARCH_TERM](state, searchTerm) {
    state.storeData.searchTerm = searchTerm;
  },
  [UPDATE_STORE_SEARCH_ERROR](state, error) {
    state.storePickupValidation.hasError = error;
  },
  [UPDATE_STORE_SEARCH_WARNING](state, warning) {
    state.storePickupValidation.hasWarning = warning;
  },
  [SET_GEOLOCATION_ERROR](state, err) {
    state.storeData.geoLocationError = err;
  },
  [UPDATE_STORE_SEARCH_PROBLEM_MESSAGE](state, msg) {
    state.storePickupValidation.problemMessage = msg;
  },
  [UPDATE_STORE_SEARCH_BOX_REF](state, el) {
    state.storePickupValidation.searchBoxEl = el;
  },
  [UPDATE_STORES_LOADING](state, loading) {
    state.storeData.isLoading = loading;
  },
  [UPDATE_BUYBOX_VALIDATION](state, validationData) {
    const newState = {
      ...state.buyBoxValidation,
      ...validationData
    };
    state.buyBoxValidation = newState;
  },
  [UPDATE_RECOMMENDATIONS_SCRIPT_STATUS](state, {
    loaded,
    hasError
  }) {
    state.richRelevance.loaded = loaded || state.richRelevance.loaded;
    state.richRelevance.hasError = hasError || state.richRelevance.hasError;
  },
  [UPDATE_RECOMMENDATIONS_PLACEMENTS](state, placements) {
    state.richRelevance.placements = {
      ...state.richRelevance.placements,
      ...placements
    };
  },
  [UPDATE_BV_SCRIPT_STATUS](state, {
    loaded,
    hasError
  }) {
    state.bvReviews.loaded = loaded || state.bvReviews.loaded;
    state.bvReviews.hasError = hasError || state.bvReviews.hasError;
  },
  [UPDATE_WISHLISTS](state, wishlists) {
    state.wishlist.allWishlists = wishlists;
  },
  [UPDATE_WISHLIST_ERROR](state, error) {
    state.wishlist.hasError = error.hasError;
    state.wishlist.errorCode = error.errorCode;
  },
  [SET_CURRENT_WISHLIST](state, wishlist) {
    state.wishlist.selectedWishlist = wishlist;
  },
  [CLEAR_SELECTED_WISHLIST](state) {
    state.wishlist.selectedWishlist = {
      list: {
        id: "",
        name: ""
      }
    };
  },
  [UPDATE_CART_DATA](state, cartData) {
    state.cartData = cartData;
  },
  [UPDATE_CART_ERROR_DATA](state, cartErrorData) {
    state.cartErrorData = cartErrorData;
  },
  [UPDATE_CART_LOAD_STATUS](state, status) {
    state.cartLoadState = status;
  },
  /**
   * @param {*} state Vuex state
   * @param {boolean} user.isLoggedIn
   * @param {boolean} user.isMember
   */
  [UPDATE_USER](state, user) {
    state.user = user;
  },
  [TOGGLE_ACCORDION_SECTION](state, id) {
    state.accordionStatus[id] = !state.accordionStatus[id];
  },
  [TOGGLE_ACCORDION_VISIBILITY](state, status) {
    state.accordionStatus.isVisible = status;
  },
  [UPDATE_HERO_IMAGE](state, image) {
    state.media.currentImage = image;
  },
  [SET_USE_VERTICAL_ANIMATION](state, useVerticalAnimation) {
    state.media.useVerticalAnimation = useVerticalAnimation;
  },
  [SET_ARIA_LIVE_MESSAGE](state, message) {
    state.ariaLive.message = message;
  },
  [SET_ARIA_LIVE_POLITENESS](state, politeness) {
    state.ariaLive.politeness = politeness;
  },
  [SET_RECS_COMPONENT](state, component) {
    state.richRelevance.component = component;
  },
  [SET_BOPUS_ANALYTICS_LINKNAME](state, linkName) {
    state.storeData.linkName = linkName;
  },
  [SET_SIZE_HOVER_NAME](state, size) {
    state.tempSize = size;
  },
  [UPDATE_SELECTED_SKU](state, sku) {
    state.selectedSku = sku;
  },
  [CLEAR_SKU_ERROR](state) {
    state.buyBoxValidation.sku.hasError = false;
  },
  [UPDATE_VIEWED_SKUS](state, sku) {
    if (sku) {
      state.viewedSkus[sku] = true;
    }
  },
  [UPDATE_ACCEPT_TERMS](state, status) {
    state.acceptTermsConditions = status;
  },
  [UPDATE_SELECTED_PRICE](state, price) {
    state.selectedPrice = price;
  },
  [SET_HOVER_PRICE](state, price) {
    state.tempPrice = price;
  },
  [UPDATE_INCLUDE_MEMBERSHIP](state, status) {
    state.includeMembership = status;
  },
  [CLEAR_MEMBERSHIP_ERROR](state) {
    state.buyBoxValidation.membership.hasError = false;
  },
  [SHOW_ZOOM](state, show) {
    state.imageZoom.showZoom = show;
  },
  [SET_IMAGE_ZOOM_REF](state, ref) {
    state.imageZoom.buttonRef = ref;
  },
  [SET_TOUCH_LIBRARY](state, library) {
    state.imageZoom.library = library;
  },
  [SET_USER_SUBSCRIPTION](state, sub) {
    state.userSubscription = sub;
  },
  [UPDATE_NOTIFY_ME_EMAIL](state, email) {
    state.notifyMe.email = email;
  },
  [SET_NOTIFY_ME_ERROR](state, message) {
    state.buyBoxValidation.notifyMe.hasError = true;
    state.notifyMe.errorMessage = message;
  },
  [CLEAR_NOTIFY_ME_ERROR](state) {
    state.buyBoxValidation.notifyMe.hasError = false;
    state.notifyMe.errorMessage = "";
  },
  [UPDATE_NOTIFY_ME_SUCCESS](state, sku) {
    state.notifyMe.skusNotified.push(sku);
  },
  [UPDATE_CART_LOAD_MEMBERSHIP_STATUS](state, status) {
    state.cartLoadMembershipState = status;
  },
  [UPDATE_ADOBE_TEST_DATA](state, testData) {
    state.adobeTestData = testData;
  },
  [UPDATE_URL_SEARCH_PARAMS](state, params) {
    state.urlSearchParams = params;
  },
  [UPDATE_SIZE_FINDER_RESULTS](state, sizes) {
    state.sizeFinderResults = sizes;
  },
  [UPDATE_SIZE_FINDER_FEET_SELECTED](state, feet) {
    state.sizeFinderSelectedSize.feet = feet;
  },
  [UPDATE_SIZE_FINDER_INCHES_SELECTED](state, inches) {
    state.sizeFinderSelectedSize.inches = inches;
  },
  [UPDATE_COMPONENT_MOUNTED](state, component) {
    state.asyncComponentsMounted[component] = true;
  },
  [UPDATE_SHIPPING_ADDRESS](state, address) {
    state.shipping.shippingAddress = address;
  },
  [UPDATE_PICKUP_MODAL_STORE](state, isPickupModalStoreSet) {
    state.isPickupModalStoreSet = isPickupModalStoreSet;
  },
  [UPDATE_SHIPPING_AVAILABILITY](state, availability) {
    state.shipping.shippingAvailability = availability;
  },
  [CLEAR_SHIPPING_AVAILABILITY](state) {
    state.shipping.shippingAvailability = {
      errorMessages: null,
      estimatedArrivalDate: "",
      estimatedArrivalTimestamp: null,
      fulfilledQuantity: 1,
      fulfillmentServiceLevel: "",
      fulfillmentType: "",
      hasErrors: null
    };
  },
  [SET_INLINE_SHIP_EDITOR_OPEN](state, isOpen) {
    state.shipping.inlineShippingEditorOpen = isOpen;
  },
  [SET_INLINE_SHIP_LOADING](state, isLoading) {
    state.shipping.inlineLoading = isLoading;
  },
  [SET_SHIP_GEO_ERROR](state, hasError) {
    state.shipping.hasGeolocationError = hasError;
  },
  [SET_INLINE_SHIP_INVALID](state, invalid) {
    state.shipping.inlineEditorIsInvalid = invalid;
  },
  [SET_HAS_EAD_NETWORK_ERROR](state, hasError) {
    state.shipping.hasNetworkError = hasError;
  },
  [SET_NO_STORE_AVAILABLE](state, available) {
    state.shipping.noStoreAvailable = available;
  },
  [SET_NO_LOCATION_AVAILABLE](state, available) {
    state.shipping.noLocationAvailable = available;
  },
  [SET_USER_DEFINED_STORE](state, storeData) {
    state.userSelectedStoreData = storeData;
  },
  [SET_UGC_IMAGES](state, images) {
    state.ugcImageResponse = images;
  },
  [SET_CURRENT_UGC_PRODUCT](state, product) {
    state.currentUgcProduct = product;
  },
  [LIMIT_INSTOCK_STORES](state, shouldLimit) {
    state.limitStoresToInStock = shouldLimit;
  },
  [SET_MEMBERSHIP_ADDED_TO_CART_STATUS](state, status) {
    state.membershipAddedToCart = status;
  },
  [SET_SHOW_ATC_INTERSTITIAL](state, show) {
    state.showAddToCartInterstitial = show;
  },
  [SET_POP_STATE_CB](state, cb) {
    state.popstateCallback = cb;
  },
  [SET_CART_MICROSERVICE_DATA](state, cart) {
    state.cartMicroserviceData = cart;
  },
  [SET_CART_SUMMARY](state, data) {
    state.cartSummary = data;
  },
  [SET_CART_MICROSERVICE_ERROR_DATA](state, errorData) {
    state.cartMicroserviceErrorData = errorData;
  },
  [SET_PRODUCT_INSIGHT](state, sitkaData) {
    state.sitkaData = sitkaData;
  },
  [SET_CUSTOMER_ATTRIBUTES](state, data) {
    state.customerAttributes = data;
  },
  [SET_OVER_REQUEST_MESSAGE](state, data) {
    state.overRequestMessage = data;
  },
  [SET_STORYTELLING_DATA](state, data) {
    state.storytelling = data;
  },
  [SET_ADVICE_DATA](state, data) {
    state.buyingAdvice = data;
  },
  [SET_CURATED_OUTFIT_DATA](state, data) {
    state.curatedOutfitData = data;
  },
  [SET_ORDER_ISSUES](state, orderIssues) {
    state.shipping.orderIssues = orderIssues;
  },
  [UPDATE_KLARNA_SCRIPT_STATUS](state, {
    loaded,
    hasError
  }) {
    state.klarna.loaded = loaded || state.klarna.loaded;
    state.klarna.hasError = hasError || state.klarna.hasError;
  }
};
export {
  mutations as default
};
//# sourceMappingURL=mutations.mjs.map
